import type { Locale } from '@infiltre/shared';
import { useUiStore } from '@/shared/hooks/use-shallow-store';
import { interpolate } from './format';
import { type MessageKey, messages } from './messages';

export type Translator = (key: MessageKey, vars?: Record<string, string | number>) => string;

export const useT = (): Translator => {
  const locale = useUiStore((s) => s.locale);
  return (key, vars) => interpolate(messages[locale][key], vars);
};

export const useLocale = (): Locale => useUiStore((s) => s.locale);
